module.exports = __webpack_public_path__ + "media/images/covid/traveling_safely_en-8aa25ebeddd73552a10c755e624e6c9c.jpg";